$(document).ready(function () {
    adapativFi();
});

$(window).resize(function () {
    adapativFi();
});

function adapativFi(category) {
    var w = $(window).width();
    var width_carousel = $('.tilesItemsCarousel').attr('carousel_width');
    if (w < width_carousel) {
        $('.tilesItemsCarousel').addClass('owl-carousel');
        initOwl(category);
        if (window.location.pathname == '/' || window.location.pathname == '/en' || window.location.pathname == '/ru' || window.location.pathname == '/it' || window.location.pathname == '/uk'  ) {
            $('.tilesItemsCarousel').trigger('refresh.owl.carousel');
        }
    } else {
        $('.tilesItemsCarousel').trigger('destroy.owl.carousel');
    }
}

function initOwl(category) {
    item = $('.tilesItemsCarousel');
    if (category) {
        item = $('#resultCategory-'+category+' .tilesItemsCarousel');
    }
    item.owlCarousel({
        loop: false,
        nav: false,
        dots: true,
        margin: 5,
        items: 2,
        autoplay: false,
        startPosition: 0,
        responsive: {
            900: {
                items: 2,
                margin: 20,
            },
            768: {
                items: 2,
                margin: 10,
            },
            600: {
                items: 1,
                margin: 15,
            },
            500: {
                items: 1,
                margin: 15,
            },
            0: {
                items: 1,
                margin: 0,
            }
        }
    });
    if (category) {
        $('#resultCategory-'+category+'.tilesItems-navigations .owl-prev').on('click', function() {
            item.trigger('prev.owl.carousel');
        });

        $('#resultCategory-'+category+'.tilesItems-navigations  .owl-next').on('click', function () {
            item.trigger('next.owl.carousel');
        });
        $('#resultCategory-'+category+' .tilesItemsCarousel').on('changed.owl.carousel', function(event) {
            $('#resultCategory-'+category+' .tilesItems-navigations .navigations-currentItem').text(event.item.index+1);
        });
    } else {
        $(".tilesItems-navigations .owl-prev").on('click', function() {
            let owl = $(this).parent().siblings('.titleItems-wrapper').children('.tilesItemsCarousel').data('owl.carousel');
            owl.prev();
        });

        $(".tilesItems-navigations  .owl-next").on('click', function () {
            let owl = $(this).parent().siblings('.titleItems-wrapper').children('.tilesItemsCarousel').data('owl.carousel');
            owl.next();
        });
        $('.tilesItemsCarousel').on('changed.owl.carousel', function(event) {
            $(this).parent().siblings('.tilesItems-navigations').find('.navigations-currentItem').text(event.item.index+1);
        });
    }
}




